'use client'

import Footer from '@/components/landing-page/footer'

import {
  Box,
  Text,
  Flex,
  Icon,
  Button,
  Image,
  useDisclosure,
  Link,
} from '@chakra-ui/react'
import { Share2Icon } from 'lucide-react'

import SharePage from '@/components/how-earnings-work/share-page'
import Analytics from '../../analytics'
import { useUser } from '@/src/store/user-store'

export default function Home() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { user } = useUser()

  return (
    <>
      <div className="bg-white">
        {/* <Analytics eventType="how_earnings_works" /> */}
        <SharePage
          isOpen={isOpen}
          onClose={onClose}
          url="how-earnings-work"
        />
        <Button
          position={'fixed'}
          zIndex={100}
          right={'1em'}
          leftIcon={<Icon as={Share2Icon} />}
          bottom={'2em'}
          rounded={'full'}
          backgroundColor={'lyk-green'}
          _hover={{ opacity: 0.6 }}
          color={'white'}
          onClick={onOpen}
        >
          Share page
        </Button>

        <Box
          position={'relative'}
          className="w-full"
          id="learn-more"
          backgroundColor={'lyk-green'}
        >
          <Flex
            w={'100%'}
            justify={'space-between'}
            align={'center'}
            flexDir={['column', 'column', 'row']}
          >
            <Box
              width={'100%'}
              paddingY={['2em', '2em', '2em']}
              flex={['none', 'none', 1]}
            >
              <Box paddingLeft={[4, 4, '30%']}>
                <Text color={'white'} fontWeight={700} fontSize={30}>
                  Introducing, LYKSTAGE
                </Text>
                <Text fontSize={[24]} color={'white'}>
                  A platform for both creators and viewers to earn.
                </Text>
              </Box>
            </Box>

            <Box display={['none', 'none', 'block']} flex={[1, 1, 1.5]}>
              <Image
                src={'/how-earnings-work/hero.png'}
                alt="How Earnings Work"
              />
            </Box>

            <Box display={'flex'} justifyContent={'flex-end'}>
              <Image
                display={['block', 'block', 'none']}
                src={'/how-earnings-work/hero_mobile.png'}
                alt="How Earnings Work"
                position={['relative', 'relative', 'absolute']}
                right={0}
                left={'52px'}
                bottom={['-1em', '-1em', '-0.4em']}
                w={['90%', '90%', '55%']}
              />
            </Box>
          </Flex>
        </Box>
        <section
          className="mx-auto my-8  w-full max-w-[1200px]  grow bg-white md:my-0 md:w-[90%] md:py-8"
          id="learn-more"
        >
          <div className="flex w-full flex-col items-center justify-center gap-5 overflow-hidden px-4 py-5 md:px-16 lg:flex-row lg:px-16">
            <div className="flex w-full flex-1 flex-col pr-0 sm:text-center lg:pr-16 lg:text-left">
              <h2
                className="pb-6 text-xl font-bold text-text-black sm:text-2xl md:text-3xl"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                Sounds too good to be true? It&apos;s just ads!
              </h2>

              <p
                className="text-base leading-6 text-text-black/80"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                LYKSTAGE&apos;s revenue model is designed to maximize earning
                potential for both creators and viewers through a sophisticated
                ad-serving algorithm. Unlike traditional platforms that serve
                ads at fixed intervals, LYKSTAGE uses an intelligent algorithm
                to determine when and where ads should be placed.
              </p>

              {/* <Text fontWeight={700} marginTop={5} color={'lyk-green'}>
              1 Ad set (2 Ads) - Every 5 minutes
            </Text> */}
            </div>
            <div
              className="relative mt-4 flex-1"
              data-aos="zoom-in-up"
              data-aos-anchor-placement="top-bottom"
            >
              <Image
                src="/how-earnings-work/ads.png"
                alt="Sounds too good to be true? It’s just ads!"
              />
            </div>
          </div>
        </section>

        {/* <section className="mx-auto w-full max-w-[1200px] grow  bg-white pb-16 pt-5 md:w-[90%]">
        <Section3
          title="Thoughtful viewership and earning through watch time units."
          description="LYKSTAGE rewards viewers for their time. For every minute spent watching videos, viewers earn Watch Time Units. These units are a form of digital currency (LYK Coins) on the platform, which viewers can redeem or use for various benefits, such as renting pay-per-view content."
          url="https://cdn.lykstage.com/videos/video3.mp4"
        />
      </section> */}

        <section
          className="mx-auto w-full max-w-[1200px] grow bg-white md:my-0 md:w-[90%]"
          id="learn-more"
        >
          <Flex
            flexDir={['column-reverse', 'column-reverse', 'row']}
            className="flex w-full  items-center justify-center gap-5 overflow-hidden px-4 md:px-16 lg:px-16"
          >
            <div
              className="relative flex-1"
              data-aos="zoom-in-up"
              data-aos-anchor-placement="top-bottom"
            >
              <Image
                src="/how-earnings-work/howdoesitwork.png"
                alt="Watchtime"
              />
            </div>
            <div className="flex w-full flex-1 flex-col pr-0 sm:text-center lg:pr-16 lg:text-left">
              <h2
                className="pb-6 text-xl font-bold text-text-black sm:text-2xl md:text-3xl"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                How does it work?
              </h2>

              <p
                className="mb-5 text-base leading-6 text-text-black/80"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                This algorithm dynamically evaluates each piece of content along with real viewer engagement to determine if and when ads should be served — as pre-roll, mid-roll, or post-roll.
                <br /><br />
                When an ad is served during viewing and watched fully, the watch time built on that content becomes monetized — enabling creator earnings and viewer rewards. Monetization happens only when genuine viewing leads to ads being served and completed — ensuring value is created through real attention, not ad volume.
              </p>

              <Box display={['none', 'none', 'block']}>
                <br />
                <br />
              </Box>
            </div>
          </Flex>
        </section>

        <Box marginTop={'-3em'} bg={'lyk-green'} h={'5em'} w={'100%'} />

        <Box
          position={'relative'}
          paddingY={'3em'}
          backgroundColor={'#3E3E3E'}
          color={'white'}
        >
          <Image
            position={'absolute'}
            top={'1em'}
            right={'0'}
            alt="Circles"
            src="/how-earnings-work/circles.png"
            w={'9em'}
          />
          <Box marginX={'auto'} maxW={['90%', '90%', '80%']}>
            <Text
              textAlign={['center', 'center', 'center']}
              marginBottom={'0.5em'}
              fontSize={36}
              fontWeight={700}
            >
              Creator Revenue Structure
            </Text>

            <Flex
              flexDir={['column', 'column', 'row']}
              gap={'2em'}
              justify={'space-between'}
              align={'center'}
            >
              <Box flex={0.75}>
                <Image
                  alt="Graph"
                  objectFit={'contain'}
                  src="/how-earnings-work/graph.png"
                  w={'100%'}
                />
              </Box>

              <Flex flexDir={'column'} gap={5} flex={1}>
                <Box
                  flex={1}
                  padding={5}
                  borderRadius={10}
                  backgroundColor={'#454D4C'}
                >
                  <Text color={'lyk-green'}>For creators, starts at:</Text>

                  <Flex
                    flexDir={['column', 'column', 'row']}
                    gap={'1em'}
                    align={['flex-start', 'flex-start', 'center']}
                  >
                    <Text
                      fontSize={45}
                      whiteSpace={'nowrap'}
                      flex={1}
                      fontWeight={600}
                      color={'lyk-green'}
                    >
                      45%-70%
                    </Text>
                    <Text fontWeight={500} flex={1.75} fontSize={16}>
                      The cut creators make on the total revenue generated on
                      the video.
                    </Text>
                  </Flex>
                </Box>

                <Box
                  flex={1.25}
                  padding={5}
                  borderRadius={10}
                  backgroundColor={'#F5888412'}
                >
                  <Text color={'lyk-red'}>For viewers:</Text>
                  <Flex
                    flexDir={['column', 'column', 'row']}
                    gap={'1em'}
                    align={['flex-start', 'flex-start', 'center']}
                  >
                    <Text fontSize={45} fontWeight={600} color={'lyk-red'}>
                      *30%
                    </Text>
                    <Text fontWeight={500} fontSize={16}>
                      <Text fontWeight={700} color={'lyk-red'} as={'span'}>
                        *of remaining revenue
                      </Text>{' '}
                      after creator split, is left for all viewers. You earn
                      from that pool based on your Watch time units consumption!
                    </Text>
                  </Flex>
                </Box>
              </Flex>

              <Box
                flex={0.4}
                padding={5}
                borderRadius={10}
                backgroundColor={'#454D4C'}
                paddingY={'60px'}
              >
                <Flex marginBottom={1} gap={'0.25em'} align={'center'}>
                  <Image w={'1em'} src="/disclaimer.svg" alt="Disclaimer" />
                  <Text fontWeight={600} fontSize={17} color={'lyk-green'}>
                    Disclaimer
                  </Text>
                </Flex>

                <Text fontWeight={500} flex={1.75} fontSize={16}>
                  With LYKSTAGE, viewers earn rewards for watchtime if logged in
                  and ads are served.{' '}
                  <Text as={'span'} color={'lyk-green'}>
                    No ads mean no earnings for both creators and viewers.
                  </Text>
                </Text>
              </Box>
            </Flex>
          </Box>
        </Box>

        <br />
        <br />

        {/* <Box
        bg={'#454D4C'}
        rounded={'xl'}
        color={'white'}
        padding={10}
        position={'relative'}
        marginTop={'10em'}
        margin={'auto'}
        maxW={['90%', '90%', '60%']}
      >
        <Flex
          flexDir={['column', 'column', 'row']}
          align={['flex-start', 'flex-start', 'center']}
        >
          <Image
            src="/how-earnings-work/character.png"
            alt="Exclamation mark"
            w={['7em', '7em', '3em']}
            marginLeft={[0, 0, '-5em']}
            transform={[null, null, 'scale(5)']}
            marginBottom={[5, 5, 0]}
          />
          <Text marginLeft={[0, 0, '8em']}>
            With LYKSTAGE, viewers earn rewards based on their watchtime,
            <Text as={'span'} fontWeight={700} color={'lyk-green'}>
              provided they are logged into their accounts
            </Text>
            . This ensures that your viewing activity is tracked accurately,
            allowing you to benefit from the time you spend watching content on
            our platform.
          </Text>
        </Flex>
      </Box> */}

        <section
          className="mx-auto my-6 mb-0 w-full max-w-[1200px] grow bg-white  md:w-[90%] md:py-8"
          id="learn-more"
        >
          <div className="flex w-full flex-col items-center justify-center gap-5 overflow-hidden px-4 py-5 md:px-16 lg:flex-row lg:px-16">
            <div className="flex w-full flex-1 flex-col pr-0 sm:text-center lg:pr-16 lg:text-left">
              <h2
                className="pb-6 text-xl font-bold text-text-black sm:text-2xl md:text-3xl"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                Start earning with your watchtime!
              </h2>

              <p
                className="mb-5 text-base leading-6 text-text-black/80"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                With LYKSTAGE, viewers are rewarded for their Watchtime.
              </p>

              <p
                className="text-base leading-6 text-text-black/80"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                A unit of watch time can be defined as a block of 30 sec
                uninterrupted video viewing. Each watchtime in a video in a 24
                hour period allows you to earn from that videos total revenue!
              </p>

              <Text fontWeight={700} marginTop={5} color={'lyk-green'}>
                For a viewer, in a 24 hour period, your watchtime units cap out
                at 6 hours!
              </Text>
            </div>
            <div
              className="relative mt-[-10px] flex-1"
              data-aos="zoom-in-up"
              data-aos-anchor-placement="top-bottom"
            >
              <Image src="/how-earnings-work/watchtime.png" alt="Watchtime" />
            </div>
          </div>
        </section>

        <section
          className="mx-auto my-4 w-full max-w-[1200px] grow bg-white md:my-0 md:w-[90%] md:py-8"
          id="learn-more"
        >
          <Flex
            flexDir={['column-reverse', 'column-reverse', 'row']}
            className="flex w-full  items-center justify-center gap-5 overflow-hidden px-4 py-5 md:px-16 lg:px-16"
          >
            <div
              className="relative mt-10 flex-1"
              data-aos="zoom-in-up"
              data-aos-anchor-placement="top-bottom"
            >
              <Image src="/how-earnings-work/ad_rates.png" alt="Watchtime" />
            </div>
            <div className="flex w-full flex-1 flex-col pr-0 sm:text-center lg:pr-16 lg:text-left">
              <h2
                className="pb-6 text-xl font-bold text-text-black sm:text-2xl md:text-3xl"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                Geographical Ad Rates
              </h2>

              <p
                className="mb-5 text-base leading-6 text-text-black/80"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                Ad rates differ across countries, with variations based on the
                market’s currency value, affecting the value of ad impressions
                in each country.
              </p>

              <p
                className="text-base leading-6 text-text-black/80"
                data-aos="fade-up"
                data-aos-anchor-placement="top-bottom"
              >
                For example, ad impressions may generate higher revenue in the
                USA compared to India due to the higher valuation of ad spaces
                in the American market.
              </p>

              <br />

              <Link href={'/home'}>
                <Button
                  color={'white'}
                  bg={'lyk-green'}
                  _hover={{ opacity: 0.6 }}
                >
                  Get started
                </Button>
              </Link>
            </div>
          </Flex>
        </section>

        <Box
          marginX={'auto'}
          maxW={['90%', '90%', '1100px']}
          backgroundColor={'#3E3E3E'}
          rounded={'xl'}
          color={'white'}
          padding={[8, 8, '3em']}
        // marginBottom={20}
        >
          <Flex
            flexDir={['column', 'column', 'row']}
            align={'center'}
            gap={[10, 10, 20]}
          >
            <Box flex={[1, 1, 1.4]}>
              <Text fontWeight={700} fontSize={36}>
                Premium vs Basic Creators
              </Text>
              <Text
                marginTop={1}
                marginBottom={7}
                fontWeight={500}
                fontSize={18}
              >
                You can start earning from day 1! However, as a basic creator,
                your cut would vary compared to a bigger channel - A premium
                creator. Channels with 1000+ subscribers, enjoy a special cut
                starting from 55% instead from their videos.
              </Text>

              <Link
                href={user ? '/home' : '/auth/signup'}
                backgroundColor={'lyk-red'}
                color={'white'}
                _hover={{ opacity: 0.6 }}
                py={3}
                px={7}
                borderRadius={6}
                textDecoration={'none'}
              >
                Get started &rarr;
              </Link>
            </Box>
            <Box
              w={'100%'}
              display={'flex'}
              flexDir={'column'}
              gap={'1em'}
              flex={1}
            >
              <Flex
                justify={'center'}
                align={'center'}
                color={'lyk-green'}
                backgroundColor={'#24BFA330'}
                rounded={'xl'}
                padding={3}
                w={'100%'}
              >
                <Box>
                  <Text marginBottom={'-10px'} fontSize={16} fontWeight={500}>
                    Basic Tier Creators:
                  </Text>
                  <Text fontWeight={600} fontSize={[35, 35, 52]}>
                    45% to 50%
                  </Text>
                </Box>
              </Flex>

              <Flex
                justify={'center'}
                align={'center'}
                color={'lyk-red'}
                backgroundColor={'#F5888412'}
                rounded={'xl'}
                padding={3}
                w={'100%'}
              >
                <Box>
                  <Text marginBottom={'-10px'} fontSize={16} fontWeight={500}>
                    Premium Tier Creators:
                  </Text>
                  <Text fontWeight={600} fontSize={[35, 35, 52]}>
                    52.5% to 70%
                  </Text>
                </Box>
              </Flex>
            </Box>
          </Flex>
        </Box>
        {/* ================= Creator Wallet Landing Page Version ================= */}

        <section
          className="mx-auto  mb-0 w-full max-w-[1200px] grow bg-white  md:w-[90%] md:py-8"
          id="creator-wallet"
        >
          <div className="flex w-full flex-col  gap-3 overflow-hidden px-4 py-5 md:px-16  lg:px-16">
            <h2
              className="pb-3 text-xl font-bold text-text-black sm:text-2xl md:text-3xl">
              Your Work Creates Value. Now You Can See It.
            </h2>

            <p
              className="text-base leading-6 text-text-black/80"
            >
              Earn from monetized watch time — with no follower threshold.
            </p>

            <h3 className="font-semibold mt-4 text-xl">How Creator Earnings Work</h3>

            <ul className="pl-5 text-text-black/80" style={{ listStyleType: "disc" }}>
              <li>Upload your video.</li>
              <li>Viewers watch while logged in.</li>
              <li>Ads are served during viewing.</li>
              <li>When ads are fully viewed, that session becomes monetized.</li>
              <li>Revenue is attributed to your content.</li>
              <li>Earnings appear in your Wallet.</li>
            </ul>

            <p className="text-base leading-6 text-text-black/80">
              No minimum followers. No algorithm gatekeeping. Just real engagement turning into measurable value.
            </p>

            <h3 className="font-semibold mt-4 text-xl">What You See in Your Wallet</h3>

            <ul className="pl-5 text-text-black/80" style={{ listStyleType: "disc" }}>
              <li>Monetized watch time metrics</li>
              <li>Earnings breakdown</li>
              <li>Pending vs eligible amounts</li>
              <li>Redemption status</li>
              <li>Transaction history</li>
            </ul>

            <p className="text-base leading-6 text-text-black/80">Full transparency. Clear tracking.</p>

            <h3 className="font-semibold mt-4 text-xl">Why This Model Matters</h3>

            <p className="text-base leading-6 text-text-black/80">
              Most video sharing platforms reward virality. LYKSTAGE rewards sustained attention.
              That makes it one of the most creator-aligned video sharing platforms available today.
            </p>

            <Link href={user ? '/home' : '/auth/signup'}>
              <Button bg={'lyk-green'} color={'white'} _hover={{ opacity: 0.6 }} mt={5}>
                Start Earning From Day 1
              </Button>
            </Link>
          </div>
        </section>

        {/* ================= Viewer Wallet Explainer Page Copy ================= */}

        <section
          className="mx-auto  mb-0 w-full max-w-[1200px] grow bg-white  md:w-[90%] md:py-8"
          id="viewer-wallet"
        >
          <div className="flex w-full flex-col gap-3 overflow-hidden px-4 py-5 md:px-16  lg:px-16">
            <h2 className="pb-3 text-xl font-bold text-text-black sm:text-2xl md:text-3xl">
              Your Attention Has Value.
            </h2>

            <p className="text-base leading-6 text-text-black/80">
              When your watch time qualifies, it can create rewards.
            </p>

            <h3 className="font-semibold mt-4 text-xl">How Viewer Rewards Work</h3>

            <ul className="pl-5 text-text-black/80" style={{ listStyleType: "disc" }}>
              <li>Watch while logged in.</li>
              <li>Ads are served during content.</li>
              <li>When ads are fully viewed, eligible sessions become monetized.</li>
              <li>Rewards may be tied to that monetized watch time.</li>
            </ul>

            <p className="text-base leading-6 text-text-black/80" style={{ marginTop: '1rem' }}>
              If you are not logged in, creators can still earn — but viewer rewards require login.
            </p>

            <h3 className="font-semibold mt-4 text-xl">Why This Is Different</h3>

            <p className="text-base leading-6 text-text-black/80">
              On most online video sharing platforms, viewer attention fuels revenue but goes unrecognized.
              <br />On LYKSTAGE:
              <ul className="pl-5 text-text-black/80" style={{ listStyleType: "disc" }}>
                <li>Creators earn first.</li>
                <li>Viewers can participate when eligible.</li>
                <li>Value flow becomes visible.</li>
              </ul>
            </p>

            <h3 className="font-semibold mt-4 text-xl">What You See in Your Wallet</h3>

            <ul className="pl-5 text-text-black/80" style={{ listStyleType: "disc" }}>
              <li>Reward balance</li>
              <li>Monetized watch time</li>
              <li>Redemption eligibility</li>
              <li>Transaction history</li>
            </ul>

            <p className="text-base leading-6 text-text-black/80">Your attention is measurable. And now, it’s acknowledged.</p>

            <Link href={user ? '/home' : '/auth/signup'}>
              <Button bg={'lyk-green'} color={'white'} _hover={{ opacity: 0.6 }} mt={5}>
                Start Watching
              </Button>
            </Link>
          </div>
        </section>

        <section>
          <Footer />
        </section>
      </div>
    </>
  )
}
